module.exports = __webpack_public_path__ + "img/20190729161217QQ截图20190729010013.4b4e48f3.png";